const type = 'SET_CONFIRM_ADVANCE_INVOICE_INSTALLMENT';

const setConfirmAdvanceInvoiceInstallment = () => ({
  type,
});

export { type };
export default setConfirmAdvanceInvoiceInstallment;
